import { CdkPortal, DomPortalOutlet } from '@angular/cdk/portal';
import {
  AfterViewInit,
  ApplicationRef,
  Component,
  Injector,
  ViewChild
} from '@angular/core';
import { MembershipCard } from './models/membership-card.interfaces';

@Component({
  selector: 'idp-membership-card',
  templateUrl: './membership-card.component.html',
  styleUrls: ['./membership-card.component.scss']
})
export class MembershipCardComponent implements AfterViewInit {
  content: MembershipCard = {} as MembershipCard;
  externalWindow: Window = {} as Window;

  @ViewChild(CdkPortal) cardPortalWindow!: CdkPortal;

  constructor(
    public applicationRef: ApplicationRef,
    public injector: Injector
  ) {}

  ngAfterViewInit() {
    this.externalWindow = window.open('', '') as Window;
    this.openPortalWindow(
      this.applicationRef,
      this.injector,
      this.cardPortalWindow,
      this.externalWindow
    );
  }

  openPortalWindow(
    applicationRef: ApplicationRef,
    injector: Injector,
    cardPortalWindow: CdkPortal,
    externalWindow: Window
  ) {
    this.attachStyleToPortal(externalWindow);
    this.attachLinkToPortal(externalWindow);
    this.attachMemberShipCardToPortal(
      externalWindow,
      applicationRef,
      injector,
      cardPortalWindow
    );
    setTimeout(() => {
      externalWindow.print();
    }, 2000);
  }

  attachStyleToPortal(externalWindow: Window) {
    document.querySelectorAll('style').forEach((htmlElement) => {
      if (
        htmlElement.innerHTML.includes('skymiles-landing-page-membership-card')
      ) {
        externalWindow.document.head.appendChild(htmlElement.cloneNode(true));
      }
    });
  }

  attachLinkToPortal(externalWindow: Window) {
    document.querySelectorAll('link').forEach((htmlElement) => {
      if (
        htmlElement.rel === 'stylesheet' &&
        (htmlElement.href.includes('variables.css') ||
          htmlElement.href.includes('fresh-air-fonts.css'))
      ) {
        const absoluteUrl = new URL(htmlElement.href).href;
        htmlElement.href = absoluteUrl;
        externalWindow.document.head.appendChild(htmlElement.cloneNode(true));
      }
    });
  }

  attachMemberShipCardToPortal(
    externalWindow: Window,
    applicationRef: ApplicationRef,
    injector: Injector,
    cardPortalWindow: CdkPortal
  ) {
    const host = new DomPortalOutlet(
      externalWindow.document.body,
      undefined,
      applicationRef,
      injector
    );
    host.attach(cardPortalWindow);
  }
}
